import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	meta: null,
	total: 0,
	locations: null,
	directions: null,
	nearest_location: null,
	loading_nearest: false,
	loading_details: false,
	loading_locations: false,
	loading_directions: false
};

export default function directionsReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_DIRECTIONS_REQUEST:
		case ActionTypes.GET_DIRECTIONS_ERROR:
		case ActionTypes.GET_DIRECTIONS_SUCCESS:
		case ActionTypes.GET_DIRECTIONS_LOCATIONS_REQUEST:
		case ActionTypes.GET_DIRECTIONS_LOCATIONS_ERROR:
		case ActionTypes.GET_DIRECTIONS_LOCATIONS_SUCCESS:
		case ActionTypes.GET_NEAREST_LOCATION_REQUEST:
		case ActionTypes.GET_NEAREST_LOCATION_ERROR:
		case ActionTypes.GET_NEAREST_LOCATION_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_DIRECTIONS_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_DIRECTIONS_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
